import React from 'react';
import { ChevronRight, ChevronLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { DiseaseInfo } from '../types';

interface DiseaseCardProps {
  disease: DiseaseInfo;
  onClick: (id: string) => void;
}

const DiseaseCard: React.FC<DiseaseCardProps> = ({ disease, onClick }) => {
  const { t, i18n } = useTranslation('hematology');
  const isRtl = i18n.language === 'he';
  const Chevron = isRtl ? ChevronLeft : ChevronRight;

  return (
    <button
      type="button"
      className="disease-card"
      onClick={() => onClick(disease.id)}
    >
      <span className="disease-card__abbr" dir="ltr">
        {disease.abbreviation}
      </span>

      <span className="disease-card__names">
        <span className="disease-card__name-he">
          {isRtl ? disease.nameHebrew : disease.nameEnglish}
        </span>
      </span>

      <span className="disease-card__summary">{t(disease.summaryKey)}</span>

      <Chevron className="disease-card__chevron" size={20} aria-hidden />
    </button>
  );
};

export default DiseaseCard;
